module.exports = __webpack_public_path__ + "static/media/logo.0aba8818.png";